import Api from "../../lib/api";

export const PROJECT_LIST = {
  start: "fetch_start/project_list",
  end: "fetch_end/project_list",
  success: "fetch_success/project_list",
  failed: "fetch_failed/project_list",
};

export const projectListFetchStart = () => ({
  type: PROJECT_LIST.start,
});

export const projectListFetchEnd = () => ({
  type: PROJECT_LIST.end,
});

export const projectListFetchSuccess = (data) => ({
  type: PROJECT_LIST.success,
  data,
});

export const projectListFetchFailed = (error) => ({
  type: PROJECT_LIST.failed,
  error,
});

export const updateProjectList = (
  year,
  operatingUnit,
  budgetSource,
  themes,
  keyword,
  limit,
  offset,
  budgetType,
  sdg,
  target,
  signatureSolution
) => (dispatch) => {
  dispatch(projectListFetchStart());
  operatingUnit = operatingUnit !== null ? operatingUnit : "";
  budgetType = budgetType !== null ? budgetType : "";
  year = year !== null ? year : "";
  budgetSource = budgetSource !== null ? budgetSource : "";
  themes = themes !== null ? themes : "";
  keyword = keyword !== null ? keyword : "";
  sdg = sdg ? sdg : sdg === 0 ? 0 : "";
  signatureSolution = signatureSolution ? signatureSolution : "";
  if (year !== null) {
    return Api.get(
      Api.API_PROJECT_LIST(
        year,
        operatingUnit,
        budgetSource,
        themes,
        keyword,
        limit,
        offset,
        budgetType,
        sdg,
        target,
        signatureSolution
      )
    )
      .then((response) => {
        dispatch(projectListFetchEnd());
        dispatch(projectListFetchSuccess(response.data));
      })
      .catch((exception) => {
        dispatch(projectListFetchEnd());
        dispatch(projectListFetchFailed(exception));
      });
  }
};

export const fetchMarkerProjectList = (
  year,
  markerId,
  keyword,
  limit,
  offset,
  country,
  markerType,
  levelTwoMarker
) => {
  keyword = keyword !== null ? keyword : "";
  markerType = markerType !== null ? markerType : "";
  country = country && country.country_iso3 ? country.country_iso3 : "";
  limit = limit !== null ? limit : "10";
  offset = offset !== null ? offset : "0";
  levelTwoMarker = levelTwoMarker ? levelTwoMarker : "";
  return (dispatch, getState) => {
    dispatch(projectListFetchStart());
    if (year !== "" && markerId !== "") {
      return Api.get(
        Api.API_MARKER_PROJECTLIST_DATA(
          year,
          markerId,
          keyword,
          limit,
          offset,
          country,
          markerType,
          levelTwoMarker
        )
      )
        .then((response) => {
          if (response.success && response.data) {
            response.data.aggregate =
              response.data.aggregate && response.data.aggregate.length
                ? response.data.aggregate[0]
                : {};
            dispatch(projectListFetchEnd());
            dispatch(projectListFetchSuccess(response.data));
          } else {
            dispatch(projectListFetchEnd());
          }
        })
        .catch((exception) => {
          dispatch(projectListFetchEnd());
          dispatch(projectListFetchFailed(exception));
        });
    } else {
      dispatch(projectListFetchEnd());
    }
  };
};



// WEBPACK FOOTER //
// ./shared/actions/getProjectList.js